import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import TitleContentData from './title-content-data';
import ButtonGroupContentData from './button-group-content-data';
import RichTextContentData from './rich-text-content-data';
import ArticleContentData from './article-content-data';
import ImageContentData from './image-content-data';
import AudioContentData from './audio-content-data';
import VideoContentData from './video-content-data';
import SocialMediaLinksContentData from './social-media-links-content-data';
import '../common/dialog.css';

export default class ContentDialog extends Component {
  constructor(props) {
    super(props);
    this.renderContent = this.renderContent.bind(this);
  }
  renderContent() {
    const props = {
      content: this.props.content,
      dataURL: this.props.dataURL,
      onChange: this.handleChange,
      onImageUpload: this.handleImageUpload,
      onBlur: this.handleBlur
    }
    switch(this.props.content.type) {
      case 'title':
        return <TitleContentData {...props} />
      case 'button-group':
        return <ButtonGroupContentData {...props} />
      case 'rich-text':
        return <RichTextContentData {...props} />
      case 'article':
        return <ArticleContentData {...props} />
      case 'image':
        return <ImageContentData {...props} />
      case 'audio':
        return <AudioContentData {...props} />
      case 'video':
        return <VideoContentData {...props} />
      case 'social-media-links':
        return <SocialMediaLinksContentData {...props} />
      default:
        return null;
    }
  }
  render(){
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}>
                <FontAwesome name="times"/>
              </button>
            </div>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/content-dialog.js